import { Button, Card, Typography } from "antd";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { t } from "i18next";
import SimpleLayout from "../../../core/components/layout/SimpleLayout";
import ApiService from "../../../core/service/ApiService";
import { useUser } from "../../../core/context/UserContext";

export default function PatientQueueGridApp() {
    const history = useHistory();
    const [patients, setPatients] = useState([]);
    const { firmSettings } = useUser();

    const getPatients = async () => {
        const res = await ApiService.Appointment.GetPatientQueue();
        if (res.success) {
            setPatients(res.data);
        }
    };

    useEffect(() => {
        getPatients();
        const interval = setInterval(() => {
            getPatients();
        }, 60000);
        return () => clearInterval(interval);
    }, []);


    const now = new Date();
    const formattedDate = now.toLocaleDateString();
    const formattedTime = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    const backgroundColor = "#f5f5f5";

    return (
        <SimpleLayout fullWidth={true} style={{ backgroundColor }}>
            <Card style={{ backgroundColor, boxShadow: "none", border: "none" }}>
                {/* <Button size={'small'} onClick={getPatients}>{t('Refresh')}</Button> */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                    <h2 style={{ margin: 0, color: "#000" }}>{t('Patient Queue')}</h2>
                    <Typography.Text>{`${formattedDate} ${formattedTime}`}</Typography.Text>
                </div>

                {patients.map((p, idx) => (
                    <div
                        key={idx}
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "12px",
                            marginBottom: "8px",
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        }}
                    >
                        <Typography.Text>{p.patientText}</Typography.Text>
                        <Typography.Text>{p.unitName}</Typography.Text>
                    </div>
                ))}
            </Card>
        </SimpleLayout>
    );
}